export default "__VITE_ASSET__BDRT7t_R__"